// eslint-disable-next-line no-restricted-syntax
enum ProductAttributeEnum {
    Colour = 1,
    Material = 2,
}

export default ProductAttributeEnum;
